import { ITerritorios } from "../interfaces/Territorios";
import { get } from "./fetch";

export const getTerritorios = async (id?: string): Promise<ITerritorios[]> => {
  //Stored Procedure: DashboardSituacion_Get_Programas
  var result = await get(`/api/territorios${id ? "/" + id : ""}`);
  return result;
};
